import React from "react"
import styles from "../styles/AccountNav.module.scss"

const AccountNav = ({ savedCards, signedIn }) => {
  const handleMixtapeAnchor = (e) => {
    e.preventDefault()
    mm.drawer.setState("mixtapes")
  }

  return (
    <nav className={styles.nav} aria-label="Sub Menu">
      <ol className={styles.list}>
        <li>
          <a data-bypass="true" href="/account/history">
            Order History
          </a>
        </li>
        <li>
          <a href="#editProfile" data-turbo="true" data-turbo-frame="_top">Edit Profile</a>
        </li>
        <li>
          <a href="#resetPassword" data-turbo="true" data-turbo-frame="_top">Reset Password</a>
        </li>
        {savedCards && (
          <li>
            <a href="#savedCards" data-turbo="true" data-turbo-frame="_top">Saved Cards</a>
          </li>
        )}
        <li>
          <a href="#cookiePreferences" data-turbo="true" data-turbo-frame="_top">Cookie Preferences</a>
        </li>
        <li>
          <a href="#cancelAccount" data-turbo="true" data-turbo-frame="_top">Deactivate Account</a>
        </li>
        {signedIn && (
          <li data-cy="logout" className={`${styles.logout} ${styles.user}`}>
            <a href="/logout" data-turbo="true" data-turbo-frame="_top">
              Logout
            </a>
          </li>
        )}
      </ol>
    </nav>
  )
}

export default AccountNav
